// extracted by mini-css-extract-plugin
module.exports = {"text-box":"text-box-1ukn1T705PKFDN_lCTXQsP","textBox":"text-box-1ukn1T705PKFDN_lCTXQsP"};